var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"over"}},[_c('img',{attrs:{"src":"/static/img/over.png","alt":""}}),_vm._v(" "),_c('p',{staticStyle:{"font-size":"18px"}},[_vm._v("\n       当前系统繁忙，请客官稍候再试\n    ")]),_vm._v(" "),_c('div',{staticClass:"theme-bd gohome theme-bg",on:{"click":_vm.gohome}},[_vm._v("\n        返回首页\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4615da8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/activity/overtime.vue
// module id = null
// module chunks = 